<template>
  <svg width="24" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="tw-fill-namaGray dark:tw-fill-white">
    <path
      d="M17.207 8.707L13.914 12L17.207 15.293L15.793 16.707L12.5 13.414L9.207 16.707L7.793 15.293L11.086 12L7.793 8.707L9.207 7.293L12.5 10.586L15.793 7.293L17.207 8.707ZM24.5 12C24.5 18.617 19.117 24 12.5 24C5.883 24 0.5 18.617 0.5 12C0.5 5.383 5.883 0 12.5 0C19.117 0 24.5 5.383 24.5 12ZM22.5 12C22.5 6.486 18.014 2 12.5 2C6.986 2 2.5 6.486 2.5 12C2.5 17.514 6.986 22 12.5 22C18.014 22 22.5 17.514 22.5 12Z"/>
  </svg>
</template>
